import React, { useRef, useEffect, useState } from "react";
import "./MyProjectsSection.css";


export default function MyProjectsSection() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.23 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={"my-projects-section" + (visible ? " visible" : "")}
      ref={sectionRef}
    >
      <h2 className="my-projects-title">Projects</h2>
      <div className="project-logos-row">
        <img
          className={"project-logo project-logo-animated" + (visible ? " visible" : "")}
          style={{ transitionDelay: visible ? '0.5s' : '0s' }}
          src={require("./assets/Logos/Cosmetolog logo.png")}
          alt="Cosmetolog logo"
          onClick={() => window.open("https://viktoriia.beauty", "_blank")}
        />
        <img
          className={"project-logo project-logo-animated" + (visible ? " visible" : "")}
          style={{ transitionDelay: visible ? '1.2s' : '0s' }}
          src={require("./assets/Logos/Ruina Shop logo.png")}
          alt="Ruina Shop logo"
          onClick={() => window.open("https://t.me/ruinashopbot/?start=digidro", "_blank")}
        />
        <img
          className={"project-logo project-logo-animated" + (visible ? " visible" : "")}
          style={{ transitionDelay: visible ? '1.9s' : '0s' }}
          src={require("./assets/Logos/DMK-AUTO logo.png")}
          alt="DMK-AUTO logo"
          onClick={() => window.open("https://t.me/DmkAutoBot", "_blank")}
        />
      </div>
    </section>
  );
}
